import * as React from 'react';
import RefreshStockButton from "../../../ProductListing/RefreshStockButton";
import { useSelector } from "react-redux";
import Export from "../../../../helper/export";
import { Tooltip } from "../../../../component/Tooltip";
import liveAuth from 'src/helper/liveAuth';
import exportProductCompareDataToXLS from '../../exportProductCompareDataToXLS';
import no_auth_exportProductCompareDataToXLS from '../../no_auth_exportProductCompareDataToXLS';
import Helper from 'src/support/Helper';
import { isArray, isObject } from 'underscore';
import useReduxState from 'src/hooks/useReduxState';
import CartRepository from 'src/repository/CartRepository';
import System from 'src/helper/system';
import Constants from 'src/support/Constants';

const TopRightCompareProduct = (props) => {
    const list = useSelector((state) => state.entities.model_ProductCompare.data);
    const [productInventoryList] = useReduxState([], 'setProductInventoryList');
    const [productPricingList] = useReduxState([], 'setProductPricingList');

    const getProductPricingByERPPartNumber = (ERPMFRPartNumber, ERPPartNumber,ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber; 
        if (productPricingList && productPricingList[ERPMFRPartNumber + '-' + ERPPartNumber] !== undefined
        ) {
            return productPricingList[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return false;
    };

    const getProductInventoryQuantityByERPPartNumber = (ERPPartNumber, getObject = false) => {
        if (productInventoryList && productInventoryList[ERPPartNumber] !== undefined && productInventoryList[ERPPartNumber].quantity !== undefined
        ) {
            if (getObject) {
                return productInventoryList[ERPPartNumber];
            } else {
                return productInventoryList[ERPPartNumber].quantity;
            }
        }
        return 0;
    };

    const getProductInventory = (amount, estimatedWeek) => {
        const inventoryString = 'In Stock ' + amount + ' , Factory Lead Time:' + estimatedWeek;
        return inventoryString;
    }


    const renderTooltip = (props) => (
        <>
            <RefreshStockButton />
            <br />
            Refresh the product availability to a real time call
        </>
    );

    const getProductLegends = (single_product) => {
        let res = ''
        {/*RoHS Complaint */ }
        if (single_product.ROHSCompliantCode && (single_product.ROHSCompliantCode.toUpperCase() === 'Y' || single_product.ROHSCompliantCode.toUpperCase() === 'C')) {
            res = res + single_product.ROHSCompliantCodeValue
        }

        {/* RoHS Non-Complaint */ }
        if (single_product.ROHSCompliantCode && single_product.ROHSCompliantCode.toUpperCase() === 'N') {
            res = res + single_product.ROHSCompliantCodeValue
        }

        {/* RoHS Exempt */ }
        if (single_product.ROHSCompliantCode && (single_product.ROHSCompliantCode.toUpperCase() === 'E' || single_product.ROHSCompliantCode.toUpperCase() === 'X')) {
            res = res + single_product.ROHSCompliantCodeValue
        }

        {/* NCNR Flag */ }
        if (single_product.NCNRFlag) {
            res = res + ', Non-Cancelable, Non-Returnable'
        }

        {/* Cut Tape */ }
        if (single_product.PackagingTypeCode && (single_product.PackagingTypeCode.toUpperCase() === 'BKN' || single_product.PackagingTypeCode.toUpperCase() === 'CST')) {
            res = res + ', Cut Tape'
        }

        {/* Web Only */ }
        if (single_product.WebOnlyFlag && single_product.WebOnlyFlag.toLowerCase() === 'yes') {
            res = res + ', On-line'
        }

        {/* New Product */ }
        if (single_product.NPIFlag && single_product.NPIFlag.toLowerCase() === 'yes') {
            res = res + ', New Product'
        }

        {/* Obsolete Flag */ }
        if (single_product.ObsoleteFlag) {
            res = res + ', Obsolete'
        }

        {/* Top Seller Flag */ }
        if (single_product.TopSellerFlag && single_product.TopSellerFlag.toLowerCase() === 'yes') {
            res = res + ', Top Seller'
        }

        {/* End Of Life Flag */ }
        if (single_product.EndOfLifeFlag) {
            res = res + ', End Of Life'
        }

        {/* Design Available Flag */ }
        if (single_product.IsDesignsAvailable) {
            res = res + ', Design Available'
        }

        return res
    }

    /*** Bug 9670 - Display download message on download - PN - 4 Aug 2023 */
    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg,'success')
    }

    const exportData = async () => {
        let final_Export_Data = [];
        let key_list_to_export;
        if (liveAuth.check()) {
            key_list_to_export = new exportProductCompareDataToXLS()
        } else {
            key_list_to_export = new no_auth_exportProductCompareDataToXLS();
        }
        Object.entries(list).map(async (single_product) => {
            let single_final_product = {};
            Object.entries(key_list_to_export).map((s) => {
                let key_list_to_export_field_list = s[0];
                if (single_product[1][key_list_to_export_field_list] !== undefined) {
                    if (key_list_to_export_field_list === "CustomerPartNumbers") {
                        const customerPartNumber = new CartRepository().getCustomerPartNumberFromERPPArtNumber(single_product[1].ItemNumber);
                        single_final_product[s[1]] = customerPartNumber;
                    } else {
                        single_final_product[key_list_to_export_field_list] = single_product[1][key_list_to_export_field_list] !== null && single_product[1][key_list_to_export_field_list] !== undefined ? single_product[1][key_list_to_export_field_list] : '';
                    }
                }
            });

            let quantity = 0;
            if (!quantity) {
                quantity = single_final_product.Quantity;
            }

            let erpPartNumber = Array.isArray(Object.entries(list).filter(x => x[1].PartNumber === single_final_product.PartNumber)) && Object.entries(list).filter(x => x[1].PartNumber === single_final_product.PartNumber)[0] !== undefined && Object.entries(list).filter(x => x[1].PartNumber === single_final_product.PartNumber)[0][1] !== undefined ? Object.entries(list).filter(x => x[1].PartNumber === single_final_product.PartNumber)[0][1]['ERPPartNumber'] : '';
            let erpMfrPartNumber = Object.entries(list).filter(x => x[1].PartNumber === single_final_product.PartNumber)[0][1]['ERPMFRPartNumber']

            if (liveAuth.check()) {
                single_final_product['Quantity'] = quantity;
                let inventory = getProductInventoryQuantityByERPPartNumber(erpPartNumber, true);
                single_final_product['Availability'] = inventory !== null && inventory !== undefined && inventory.plifz !== undefined && inventory.plifz != '' ? getProductInventory(inventory?.quantity, inventory?.plifz) : '';
                single_final_product['Currency'] = window.mct;
                if (erpMfrPartNumber) {
                    let price = getProductPricingByERPPartNumber(erpMfrPartNumber, erpPartNumber,single_product[1].ERPPartNumberModified);
                    const isCustomerPrice = Helper.checkIsCustomerPrice(price);
                    // Helper.rangToArray(1, 10).map((v) => {
                    //     single_final_product['PRICE_' + v] = '';
                    //     if (price[v - 1] !== undefined && price[v - 1].marketPrice !== undefined //&& single_final_product['Availability'] > 0
                    //         && Number(price[v - 1].marketPrice) > 0
                    //     ) {
                    //         single_final_product['PRICE_' + v] = isCustomerPrice ? Helper.getFormatNumber(Number(price[v - 1].marketPrice), window.mct, window.mcs, 5, false) :
                    //             Number(price[v - 1]?.demandQuantityOut) + '+: ' + Helper.getFormatNumber(Number(price[v - 1].marketPrice), window.mct, window.mcs, 5, false);
                    //     }
                    // });
                    Helper.rangToArray(1, 10).map((v) => {
                        // single_final_product['Quantity_' + v] = '';
                        single_final_product[`Tier ${v} - Quantity`] = '';
                        
                        single_final_product['PRICE_' + v] = '';
                        // DT - 17/8/23 - 10843: Compare Products- download to include qty for tier pricing
                        if (price[v - 1] !== undefined && price[v - 1].marketPrice !== undefined //&& single_final_product['Availability'] > 0
                            && Number(price[v - 1].marketPrice) > 0) {
                                single_final_product[`Tier ${v} - Quantity`] = isCustomerPrice ? "" : Number(price[v - 1]?.demandQuantityOut) + '+';
                            single_final_product['PRICE_' + v] = Helper.getFormatNumber(Number(price[v - 1].marketPrice), window.mct, window.mcs, 5, false);
                        }
                    });
                }
                single_final_product['Information'] = getProductLegends(single_product[1]);
            }

            final_Export_Data.push(single_final_product);
        });

        let f = [];
        await Promise.all(Object.entries(final_Export_Data).map((v, key) => {
            if (Object.entries(v[1]).length > 0) {
                Object.keys(v[1]).map((key, i) => {
                    if (v[1][key] === '' || v[1][key] === 0 || v[1][key] === null || (isObject(v[1][key]) && Object.entries(v[1][key]).length <= 0) || (isArray(v[1][key]) && v[1][key].length <= 0) || v[1][key] === undefined) {
                        v[1][key] = ''
                    }
                })
            }
            f.push(v[1]);
        }));

        if (f !== undefined && f.length > 0) {
            Export.toExcel(f, 'EXPORT_COMPARE_PAGE')
            showDownloadMessage();
            
        }
    };

    return (
        <>
            {Object.entries(list).length > 0 &&
                <div className="table-area-actions-right ">
                    <div className="table-area-actions-buttons me-0">
                        <Tooltip opener={() => (
                            <button className="bs5 btn btn-secondary" style={{ cursor: 'auto' }}>
                                <i className="fa fa-info-circle text-darkgreen me-2" aria-hidden="true" />
                                TOOLTIP
                            </button>)}
                            content={() => (
                                renderTooltip()
                            )}
                        />
                        <button style={{ cursor: 'pointer' }} onClick={exportData}
                            className="bs5 btn btn-secondary">Download
                        </button>
                    </div>
                </div>
            }
        </>
    );
}

export default TopRightCompareProduct;